/**
 * Tenant portal API: GET /api/tenant/me, /tenancies, /invoices,
 * /invoices/{portal_id}/pdf/url.
 * Uses same auth as admin (Bearer token from authStore); requires role=tenant.
 */
import { API_BASE_URL, getApiHeaders } from "../config";

const opts = () => ({ headers: getApiHeaders(), credentials: "include" });

export function fetchTenantMe() {
  return fetch(`${API_BASE_URL}/api/tenant/me`, opts()).then((res) => {
    if (res.status === 403) throw new Error("Kein Mieter-Zugang.");
    if (!res.ok) throw new Error("Profil konnte nicht geladen werden.");
    return res.json();
  });
}

export function fetchTenantTenancies() {
  return fetch(`${API_BASE_URL}/api/tenant/tenancies`, opts()).then((res) => {
    if (res.status === 403) throw new Error("Kein Mieter-Zugang.");
    if (!res.ok) throw new Error("Mietverhältnisse konnten nicht geladen werden.");
    return res.json();
  });
}

export function fetchTenantInvoices() {
  return fetch(`${API_BASE_URL}/api/tenant/invoices`, opts()).then((res) => {
    if (res.status === 403) throw new Error("Kein Mieter-Zugang.");
    if (!res.ok) throw new Error("Rechnungen konnten nicht geladen werden.");
    return res.json();
  });
}

/**
 * Short-lived download link for ONE invoice's document.
 *
 * Addressed by `portal_id` — the opaque id the list already returns — and never
 * by a native integer or a provider id. There is deliberately no second,
 * source-specific function beside this one: the backend resolves who may see
 * which invoice, and a caller that had to pick an endpoint would be deciding a
 * question it cannot safely answer.
 *
 * The id is percent-encoded because it carries a `:` separator.
 *
 * Every failure raises the same generic message. A 404 here means "no such
 * invoice OR not yours" (the backend refuses to distinguish those on purpose)
 * and a 503 means the document specifically is unavailable; neither is
 * actionable for a tenant, and spelling out the difference would hand back the
 * information the 404 exists to withhold.
 */
export function fetchTenantInvoicePdfUrl(portalId) {
  const path = `/api/tenant/invoices/${encodeURIComponent(portalId)}/pdf/url`;
  return fetch(`${API_BASE_URL}${path}`, opts()).then((res) => {
    if (!res.ok) throw new Error("Der Rechnungsbeleg ist momentan nicht verfügbar.");
    return res.json();
  });
}
